export const companyPhone = "+420702259447";
